import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import LocationSearchTabs from './LocationSearchTabs.js';

const LocationSearchTabsContainer = (props)=>{
    const { getLabel  } = useIntl();
    const [tabIndex, setTabIndex] = React__default.useState(0);
    const ref = /*#__PURE__*/ React__default.createRef();
    const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
    const labels = React__default.useMemo(()=>({
            listTab: getLabel('locations.search.tabs.list'),
            mapTab: getLabel('locations.search.tabs.map')
        })
    , [
        getLabel
    ]);
    React__default.useEffect(()=>{
        let timeout;
        if (tabIndex === 1) {
            // setTimeout hack to prevent scrollIntoView not triggering on Mobile Devices
            // This happens specifically on Android phones when the keyboard is open and then directly clicks on the tab
            timeout = setTimeout(()=>{
                var ref1;
                const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
                    block: 'end',
                    behavior: prefersReducedMotion ? 'auto' : 'smooth'
                });
            }, 100);
        }
        return ()=>{
            clearTimeout(timeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tabIndex
    ]);
    var _showTabs;
    return /*#__PURE__*/ React__default.createElement(LocationSearchTabs, swcHelpers.extends({}, props, {
        tabsRef: ref,
        labels: labels,
        showTabs: (_showTabs = props.showTabs) !== null && _showTabs !== void 0 ? _showTabs : false,
        tabIndex: tabIndex,
        onChange: setTabIndex,
        isMobile: isMobile
    }));
};
var LocationSearchTabsContainer$1 = LocationSearchTabsContainer;

export { LocationSearchTabsContainer$1 as default };
//# sourceMappingURL=LocationSearchTabsContainer.js.map
